import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { BaseLayout } from '@platzi/ui';
import { MetricsCollector, Track } from '@platzi/commons';
import { Header, Routes, WhatIsSchool, Community, Dropdown, PlacementTest } from '../';
let sendEvent = false;
let sendAnalyticsEvent = false;

export const Layout = () => {
  const isLogged = useSelector((state) => state.get('header')?.get('isLogged')) || false;
  const userInfo = useSelector((state) => state.get('header')?.get('userInfo'))?.toJS() || {};
  const pageLoadEvent = MetricsCollector.create({ name: 'pageload' });
  pageLoadEvent.addPlugin(MetricsCollector.SessionStudentPlugin);

  useEffect(() => {
    if (sendEvent) return;
    const location = window.location;

    let payload = {
      page: 'schools',
      path_info: location.pathname,
      place_url: location.href,
      query_string: location.search,
    };

    if (isLogged) {
      if (userInfo.userId !== 0) {
        payload = {
          ...payload,
          email: userInfo.email,
          name: userInfo.name,
          user_type: userInfo.userType,
          uuid: userInfo.userId,
        };

        pageLoadEvent.send(payload);
        sendEvent = true;
      }
    } else {
      pageLoadEvent.send(payload);
      sendEvent = true;
    }
  }, [userInfo]);

  useEffect(() => {
    if (!sendAnalyticsEvent) {
      Track.send({
        event: 'schools_experiment_community',
        cookie: 'A',
      });
      sendAnalyticsEvent = true;
    }
  }, []);

  return (
    <div>
      <BaseLayout isDark>
        <Header />
        <Dropdown />
        <PlacementTest />
        <Routes />
        <WhatIsSchool />
        <Community />
      </BaseLayout>
    </div>
  );
};
